import PropTypes from 'prop-types';
import React from "react";
import styled, { css } from 'styled-components';

const Img = styled.img`
  -webkit-tap-highlight-color :  rgba(255, 255, 255, 0); 
  -webkit-touch-callout: none;
  user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
    
  ${(props) => (props.type === 'bookMenu' && css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    transition: 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  `)}

  ${(props) => (props.type === 'ebook' && css`
    position: absolute;
    top: 36px;
    left: 50%;
    transform: translateX(-50%);
    width: 1400px;
    height: auto;
    z-index: 0;
    filter: drop-shadow(0 3px 3px rgba(0,0,0,0.15));
  `)}

  ${(props) => (props.type === 'book' && css`
    position: absolute;
    top: 36px;
    left: 50%;
    transform: translateX(-50%);
    width: 1400px;
    height: auto;
    z-index: 0;
    ${(props) => (!props.act ? 'display : none;' : '')}
  `)}

  ${(props) => (props.type === 'page' && css`
    width: 100%;
    height: 100%;
  `)}

  ${(props) => (props.type === 'logo' && css`
    width: 100%;
    height: auto;
    margin-bottom: 15px;
  `)}

  ${(props) => (props.type === 'home' && css`
    width: 100%;
    height: auto;
  `)}

  ${(props) => (props.type === 'back' || props.type === 'close') && css`
    width : 100%;
    height : 100%;
  `}

  ${(props) => props.type === 'memoClose' && css`
    width: 100%;
    height: 100%;
  `}

  ${(props) => props.type === 'resource' && css`
    width: 100%;
    height: 100%;
  `}
`;

export const Image = (props) => {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <Img src={props.src} alt={props.alt} type={props.type} act={props.act}/>
  );
};

Image.propTypes = {
  src : PropTypes.string.isRequired,
  alt : PropTypes.string.isRequired,
  type : PropTypes.string,
  act : PropTypes.bool
};

Image.defaultProps = {

};